module.exports = __webpack_public_path__ + "static/pokeblox-9e39fddc5cfc6866af1ec212fa095896.png";